(() => {
  document.querySelectorAll('.question').forEach(question => {
    const arrow = question.querySelector('.arrow');
    const answer = question.nextElementSibling;
    if (!answer || !answer.classList.contains('answer')) return;

    question.addEventListener('click', () => {
      answer.classList.toggle('is-hidden');
      arrow.classList.toggle('is-down');
    });

    if (window.innerWidth < 768) {
      answer.classList.add('is-hidden');
    }
    else {
      arrow.classList.add('is-down');
    }
  });
})();
